import keyMirror from 'keymirror';

export const DndItemTypes = keyMirror({
  TEMPLATES_TEMPLATE_INFO: null,
  PARTY: null,
  SERVICE_AERIAL_TABLE: null,
  SETTINGS_AERIAL_TABLE: null,
});
